type SidebarContextType = {
  sidebarOpen: boolean;
  setSidebarOpen: (isOpen: boolean) => void;
  navItems: NavItem[];
  windowViewportWidth: number;
  setWindowViewportWidth: React.Dispatch<React.SetStateAction<number>>;
  viewAreaWidth: number;
  setViewAreaWidth: React.Dispatch<React.SetStateAction<number>>;
};

type NavItem = {
  id: string;
  label: string;
  icon: string;
  path: string;
  show: boolean;
  isBeta?: boolean;
};

enum GeneralViewNames {
  Adherence = 'Risk Analysis',
  Portfolio = 'Portfolio',
  Strategy = 'Strategy',
  Financials = 'Financials',
  Process = 'Process Map',
  ProcessAnalysis = 'Process Analysis',
  DataManagement = 'Data Management',
  Integrations = 'Integrations',
  Dashboards = 'Dashboards',
  Automation = 'Automation',
  WorkPeriods = 'Work Periods',
  Flora = 'Flora',
}

export { GeneralViewNames };
export type { NavItem, SidebarContextType };
